module.exports = __webpack_public_path__ + "img/close_gray.11acaef2.png";